// 不变的通用常量
export interface FileInfoType {
  create_time?: string
  file_name: string
  file_path: string
  file_size?: number
  id?: number | string
  knowledge_id?: number
  md5?: string
  object_name?: string
  remark?: string
  status?: number
  update_time?: string
  user_id?: number
}

export const MODELS_OBJ = {
  'text-embedding-ada-002': 'bge-large-zh'
}
